export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/1c51a79398276ba6cc677c7e60cd4bfb.png";